import React from "react";
import "./PPTSlideshow.css";

const PPTSlideshow = ({ pptphotoshowf_file_filedata = [], banner_default }) => {
  if (!pptphotoshowf_file_filedata || pptphotoshowf_file_filedata.length === 0) {
    return null;
  }

  return (
    <div className="pptslideshow-container">
      {pptphotoshowf_file_filedata.map((row, index) => (
        <img
          key={index}
          src={row.url || banner_default}
          alt={`photo-${index}`}
          className="ppt-slide active" // always active
        />
      ))}
    </div>
  );
};

export default PPTSlideshow;
